"use client";

import {JSX} from "react";

import {ExpandableTextWithButton} from "@/shared/ui/data-display/expandable-text";
import {HtmlContent} from "@/shared/ui/data-display/html-content";

interface Props {
    children: string;
}

export function WhyChooseReadMore({children}: Props): JSX.Element {
    return (
        <ExpandableTextWithButton maxLines={12} buttonClassName="why_choose_us__readmore-button" buttonSize="sm" buttonMarginTop={12}>
            <HtmlContent html={children}></HtmlContent>
        </ExpandableTextWithButton>
    );
}
